<template>
  <div>
      <div class="team-header__description" v-if="teamData?.statement">
          <div class="team-header__description-title">
              About the team
          </div>
          <div class="team-header__description-text" v-html="teamData.statement"></div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'TeamAbout',
  props: {
      teamId: {
          type: Number,
          required: true,
      },
      teamData: {
          type: Object,
          required: true,
      },
      isAdmin: {
          type: Boolean,
          required: false,
      },
      isUserLoggedIn: {
          type: Boolean,
          required: false,
      },
  },
  data() {
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.team-header {
  overflow: hidden;
  padding: 0 var(--global-dimension-size-300) var(--global-dimension-size-400);
  background-color: var(--color-gray-50);
  border-radius: var(--border-radius-base);
  margin-bottom: 30px;
  line-height: 1.6;

  &__description {
    margin-top: var(--global-dimension-size-350);
    font-size: var(--font-size-200);
    background-color: white;
    padding: var(--global-dimension-size-200);
    border-radius: var(--border-radius-base);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &-title {
      background-color: var(--color-primary-500);
      color: white;
      font-weight: var(--global-font-weight-bold);
      padding: var(--global-dimension-size-125);
      border-top-left-radius: var(--border-radius-base);
      border-top-right-radius: var(--border-radius-base);
      margin-bottom: var(--global-dimension-size-125);
    }

    &-text {
      white-space: pre-wrap;
    }
  }
}
</style>
